import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  withHandlers,
  lifecycle
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Text } from 'recharts';
// import CloseButon from '../../components/atoms/CloseButton';
import Button from '@material-ui/core/Button';
import {
  getGroupIdentities,
  editIdentityGroupStatus
} from '../../actions/Identity';
import { sendLogin } from '../../auth/Auth';

const styles = {
  root: {
    position: 'absolute',
    width: '95%',
    maxWidth: '355px',
    height: 'auto',
    maxHeight: '80%',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
    backgroundColor: '#fff',
    padding: 15,
    overflow: 'scroll',
    outline: 'none',
    fontSize: 12,
    lineHeight: '16px',
    color: '#333333',
    borderRadius: 4
  },
  document: {
    width: '90%',
    margin: '5px'
  },
  itemDiv: {
    margin: '20px auto',
    textLink: {
      padding: 10
    }
  },
  textIntro: {
    lineHeight: '26px',
    fontWeight: 'bold',
    fontSize: 20,
    textAlign: 'center',
    marginTop: 20
  },
  textMess: {
    fontSize: 12,
    lineHeight: '24px',
    color: '#000'
  },
  textCheckbox: {
    fontSize: 12,
    lineHeight: '16px',
    fontWeight: 500
  },
  btnCloseDiv: {
    textAlign: 'center'
  },
  btnClose: {
    fontSize: 14,
    fontWeight: 'bold',
    width: '100%',
    marginBottom: 25
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      name: state.loginInfo.name
    }),
    dispatch => ({
      actions: bindActionCreators(
        { getGroupIdentities, editIdentityGroupStatus },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openApprovalProgress', 'updateOpenApprovalProgress', false),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(({ classes, setOpenShopSuccess, setOpenShopOpen }) => {
  const closeAction = () => {
    setOpenShopOpen(false);
    setOpenShopSuccess(false);
    console.log('Open shop thanh cong');
  };

  return (
    <div className={classes.root}>
      <Typography className={classes.textIntro}>
        開店対応が完了しました
      </Typography>
      <div className={classes.itemDiv}>
        <Text className={classes.textMess}>
          GOCHIチケットのご利用が可能になりました。お客様が来店された際にはご対応のほど、よろしくお願いいたします。
        </Text>
      </div>
      <div className={classes.btnCloseDiv}>
        {/* <CloseButon className={classes.btnClose} onClickAction={closeAction} /> */}
        <Button
          color="primary"
          variant="contained"
          onClick={closeAction}
          className={classes.btnClose}
        >
          閉じる
        </Button>
      </div>
    </div>
  );
});

export default withRouter(withStyles(styles)(Main));
